import { render, staticRenderFns } from "./DictionaryGlossary.vue?vue&type=template&id=86ccd264&scoped=true&"
import script from "./DictionaryGlossary.vue?vue&type=script&lang=js&"
export * from "./DictionaryGlossary.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryGlossary.vue?vue&type=style&index=0&id=86ccd264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ccd264",
  null
  
)

export default component.exports